export default __webpack_public_path__ + "static/media/wishlist-empty.aa4b0eaa.jpg";